import { render } from "./VisionMissionView.vue?vue&type=template&id=56e35b93&scoped=true"
import script from "./VisionMissionView.vue?vue&type=script&lang=js"
export * from "./VisionMissionView.vue?vue&type=script&lang=js"

import "./VisionMissionView.vue?vue&type=style&index=0&id=56e35b93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e35b93"]])

export default __exports__